export default "__VITE_ASSET__CpEeQICC__"